import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IMarkerAttachment } from '@obvious.tech/constellation'

export const MarkerAttachment = defineEntity('MarkerAttachment', {
  endpoint: 'geolocation/api/MarkerAttachment',
  schema: SNoop<IMarkerAttachment>(),
})
